import type { FC } from 'react';

import styles from './Title.module.scss';
interface ITitle {
  name: string;
}

const Title: FC<ITitle> = ({ name }) => {
  return (
    <div className={styles.titleContainer}>
      <h2 className={styles.titleText}>{name}</h2>
    </div>
  );
};

export default Title;
